import { render } from "./PRPMicroneedlingFacialContentEs.vue?vue&type=template&id=13dc7232"
import script from "./PRPMicroneedlingFacialContentEs.vue?vue&type=script&lang=js"
export * from "./PRPMicroneedlingFacialContentEs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__